import { FileDownload, NotInterested } from "@mui/icons-material";
import { IconButton } from "@mui/material";

export const COLUMNSMIPGDCOLABORADOR = [
  {
    accessorKey: "id",
  },
  {
    header: "Periodo",
    accessorKey: "periodo",
    size: 50,
    minSize: 100,
    maxSize: 200,
    Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
  },
  {
    header: "Etapa",
    accessorKey: "instancia",
    size: 50,
    minSize: 100,
    maxSize: 200,
    Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
  },
  {
    header: "Fecha de inicio de la etapa",
    accessorKey: "inicio",
    size: 50,
    minSize: 100,
    maxSize: 200,
    Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
  },
  {
    header: "Fecha de finalización de la etapa",
    accessorKey: "finalizacion",
    size: 50,
    minSize: 100,
    maxSize: 200,
    Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
  },
  {
    header: "Estado de la etapa",
    accessorKey: "estadoEtapa",
    size: 50,
    minSize: 100,
    maxSize: 200,
    Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
  },
  {
    header: "Score Objetivos",
    accessorKey: "scoreObjetivos",
    size: 50,
    minSize: 100,
    maxSize: 200,
    Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
  },
  {
    header: "Score Competencias",
    accessorKey: "scoreCompetencias",
    size: 50,
    minSize: 100,
    maxSize: 200,
    Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
  },


]
export const COLUMNSMIPGDFINALIZADOS = [
  {
    accessorKey: "id",
  },
  {
    header: "Descargar",
    accessorKey: "annotations",
    size: 50,
    minSize: 100,
    maxSize: 200,
    Cell: ({ cell }) => (
      <>
        {(cell.getValue() && cell.getValue().length > 0 && cell.getValue()[0].annotationid  && cell.getValue()[0].mimetype === 'application/pdf') ? (
          <IconButton>
            <FileDownload onClick={() => handleDownload(cell.getValue())} />
          </IconButton>
        ) : (
          <span style={{ padding: '0 0.5rem' }}>
            <NotInterested />
          </span>
          )
        }
      </>
    ),
  },
  {
    header: "Periodo",
    accessorKey: "periodo",
    size: 50,
    minSize: 100,
    maxSize: 200,
    Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
  }, {
    header: "Fecha de inicio de la PGD",
    accessorKey: "inicio",
    size: 50,
    minSize: 100,
    maxSize: 200,
    Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
  },
  {
    header: "Fecha de finalización de la PGD",
    accessorKey: "finalizacion",
    size: 50,
    minSize: 100,
    maxSize: 200,
    Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
  },
]


const handleDownload = (annotations) => {
  if (Array.isArray(annotations) && annotations.length > 0) {
    annotations.forEach(annotation => {
      const { mimetype, documentbody, filename } = annotation;

      // Verificar si el mimetype es PDF antes de intentar descargar
      if (mimetype === 'application/pdf') {
        downloadBase64File(mimetype, documentbody, filename);
      } else {
        // Manejar el caso de otros tipos de archivos (opcional)
        console.warn(`No se descargará el archivo (${filename}) porque no es un PDF.`);
      }
    });
  } else {
    // Manejar el caso donde no hay annotations
    console.error("No hay annotations para descargar.");
  }
};

const downloadBase64File = (contentType, base64Data, fileName) => {
  if (contentType && base64Data && fileName) {
    const linkSource = `data:${contentType};base64,${base64Data}`;
    const downloadLink = document.createElement("a");
    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();
  }
};

export const COLUMNSPGDEQUIPO = [
  {
    accessorKey: "id",
  },
  {
    header: "Periodo",
    accessorKey: "periodo",
    size: 50,
    minSize: 100,
    maxSize: 200,
    Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
  },
  {
    header: "Evaluado",
    accessorKey: "evaluado",
    size: 50,
    minSize: 100,
    maxSize: 200,
    Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
  },
  {
    header: "Etapa",
    accessorKey: "instancia",
    size: 50,
    minSize: 100,
    maxSize: 200,
    Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
  },
  {
    header: "Inicio",
    accessorKey: "inicio",
    size: 50,
    minSize: 100,
    maxSize: 200,
    Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
  },
  {
    header: "Fin",
    accessorKey: "finalizacion",
    size: 50,
    minSize: 100,
    maxSize: 200,
    Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
  },
  {
    header: "Estado de la etapa",
    accessorKey: "estadoEtapa",
    size: 50,
    minSize: 100,
    maxSize: 200,
    Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
  },
  {
    header: "Score Objetivos",
    accessorKey: "scoreObjetivos",
    size: 50,
    minSize: 100,
    maxSize: 200,
    Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
  },
  {
    header: "Score Competencias",
    accessorKey: "scoreCompetencias",
    size: 50,
    minSize: 100,
    maxSize: 200,
    Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
  },

]
export const COLUMNSPGDEQUIPOFINALIZADOS = [
  {
    accessorKey: "id",
  },
  {
    header: "Descargar",
    accessorKey: "annotations",
    size: 50,
    minSize: 100,
    maxSize: 200,
    Cell: ({ cell }) => (
      <>
        {(cell.getValue() && cell.getValue().length > 0 && cell.getValue()[0].annotationid  && cell.getValue()[0].mimetype === 'application/pdf') ? (
          <IconButton>
            <FileDownload onClick={() => handleDownload(cell.getValue())} />
          </IconButton>
        ) : (
          <span style={{ padding: '0 0.5rem' }}>
            <NotInterested />
          </span>
          )
        }
      </>
    ),
  },
  {
    header: "Evaluado",
    accessorKey: "evaluado",
    size: 50,
    minSize: 100,
    maxSize: 200,
    Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
  },
  {
    header: "Periodo",
    accessorKey: "periodo",
    size: 50,
    minSize: 100,
    maxSize: 200,
    Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
  },
  {
    header: "Fecha de inicio de la PGD",
    accessorKey: "inicio",
    size: 50,
    minSize: 100,
    maxSize: 200,
    Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
  },
  {
    header: "Fecha de finalización de la PGD",
    accessorKey: "finalizacion",
    size: 50,
    minSize: 100,
    maxSize: 200,
    Cell: ({ cell }) => <strong>{cell.getValue()}</strong>,
  },
]
